// src/components/Admin/dashboard/DashboardHeader.jsx
import React from 'react';

const DashboardHeader = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-semibold text-gray-900">Dashboard Overview</h1>
    </div>
  );
};

export default DashboardHeader;